"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _opacity = _interopRequireDefault(require("./opacity"));

var _accent = _interopRequireDefault(require("./accent"));

var _primary = _interopRequireDefault(require("./primary"));

var action = {
  active: _opacity["default"].black[60],
  "delete": (0, _colorManipulator.fade)(_accent["default"].redDark, 0.08),
  disabled: _opacity["default"].black[38],
  disabledBackground: _opacity["default"].black[14],
  hover: _opacity["default"].black[8],
  hoverOpacity: 0.08,
  selected: (0, _colorManipulator.fade)(_primary["default"][600], 0.14)
};
var _default = action;
exports["default"] = _default;